module.exports = __webpack_public_path__ + "static/media/SERVICIO_DE_CREMACION.e3242440.png";